import { useState } from "react";
import { scheduleAuthSuccessRedirect } from "./authSuccessRedirect";

export const useAuthSuccessRedirect = () => {
  const [success, setSuccess] = useState(false);

  const handleAuthSuccess = (redirectUrl: string) => {
    setSuccess(true);
    scheduleAuthSuccessRedirect(redirectUrl);
  };

  return { success, handleAuthSuccess };
};
